import React from "react"; 
import {LogosComponent} from "../../components/Logos/Logos"

export const  AnimateLogos = () => (
    <LogosComponent/>
);
